module.exports = __webpack_public_path__ + "static/img/kids_bg.f1b524dd.png";